import { createSlice } from "@reduxjs/toolkit";

const platformPermissionsSlice = createSlice({
    name: "platformPermissions",
    initialState: [],
    reducers: {
        setPlatformPermissions(state, action) {
            return action.payload;
        },
    },
});

export const { setPlatformPermissions } = platformPermissionsSlice.actions;
export default platformPermissionsSlice.reducer;